// ==================== PHASE 30 (2026-08-16): compensazione altezza barra di anteprima Shopify ====================
// CAUSA REALE del pulsante Checkout invisibile nella "Preview normale" (ma visibile nel Theme
// Editor): quando un membro dello staff/account owner visualizza un tema NON pubblicato tramite
// un link di anteprima diretto (fuori dal Theme Editor), Shopify inietta realmente nella pagina
// una propria barra fissa in fondo allo schermo (iframe #preview-bar-iframe, con nome tema, stato
// Draft, selettore "View as" e pulsante "Edit theme") -- SOLO per chi e' loggato come staff su un
// tema non pubblicato: i clienti reali sul sito pubblicato non la vedono MAI. Questa barra e' un
// overlay aggiunto da Shopify stesso, quindi NON riduce window.innerHeight ne' i valori 100vh /
// 100dvh calcolati dal motore CSS: il cart drawer, dimensionato a piena altezza, risultava quindi
// "tecnicamente" dentro al viewport per la matematica flex, ma visivamente il pulsante Checkout in
// fondo al drawer finiva coperto da questa barra reale. Nel Theme Editor la barra non esiste (li'
// la UI dell'editor sta fuori dall'iframe del contenuto), motivo per cui li' il pulsante era
// sempre visibile correttamente.
// Qui misuriamo l'altezza reale della barra (se presente) e la esponiamo come variabile CSS
// (--sc-preview-bar-h), cosi' il drawer puo' sottrarla dalla propria altezza in solcozm-theme-ext.css.
// Sul sito pubblicato la barra non esiste mai: la variabile resta 0 e il drawer usa sempre la
// piena altezza, esattamente come prima.
(function () {
  function scMeasurePreviewBar() {
    var bar = document.getElementById('PBarNextFrameWrapper');
    var h = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--sc-preview-bar-h', h + 'px');
  }
  scMeasurePreviewBar();
  window.addEventListener('resize', scMeasurePreviewBar);
  window.addEventListener('load', scMeasurePreviewBar);
  // La barra puo' comparire con un piccolo ritardo rispetto al parsing iniziale della pagina, e
  // l'utente puo' espanderla/collassarla manualmente (controllo nativo Shopify): ricontrolliamo
  // periodicamente nei primi secondi, poi restiamo sincronizzati con un ResizeObserver.
  [300, 800, 1500, 3000].forEach(function (delay) {
    window.setTimeout(scMeasurePreviewBar, delay);
  });
  if ('ResizeObserver' in window) {
    var scPreviewBarObserver = new ResizeObserver(scMeasurePreviewBar);
    var scAttachPreviewBarObserver = function () {
      var bar = document.getElementById('PBarNextFrameWrapper');
      if (bar) scPreviewBarObserver.observe(bar);
    };
    scAttachPreviewBarObserver();
    window.setTimeout(scAttachPreviewBarObserver, 800);
    window.setTimeout(scAttachPreviewBarObserver, 1500);
  }
})();

// ==================== PHASE 32 (2026-08-17): logo SOLCOZM nell'header mobile della homepage a cavallo tra barra promo bianca e header beige ====================
// CAUSA REALE: .sc-header--transparent usa position:absolute; top:0 senza alcun antenato posizionato,
// quindi e' ancorato all'origine assoluta della pagina e si sovrappone alla .utility-bar (barra promo) che la precede nel flusso.
// Il logo resta dentro l'header solo perche' il padding-top dell'header (34px sotto i 480px) di solito supera l'altezza
// reale della barra promo. Su mobile il testo della barra va su 2 righe (~54px), superando quel margine: il logo finisce
// a cavallo tra bianco e beige. Qui misuriamo l'altezza reale della .utility-bar e la esponiamo come variabile CSS
// (--sc-announcement-h), cosi' solcozm-theme-ext.css puo' ancorare l'header sotto la barra promo SOLO su mobile,
// senza toccare desktop/tablet.
(function () {
  function scMeasureAnnouncementBar() {
      var bar = document.querySelector('.utility-bar__grid') || document.querySelector('.utility-bar');
          var h = bar ? bar.getBoundingClientRect().height : 0;
              document.documentElement.style.setProperty('--sc-announcement-h', h + 'px');
                }
                  scMeasureAnnouncementBar();
                    window.addEventListener('resize', scMeasureAnnouncementBar);
                      window.addEventListener('load', scMeasureAnnouncementBar);
                        [300, 800, 1500, 3000].forEach(function (delay) {
                            window.setTimeout(scMeasureAnnouncementBar, delay);
                              });
                                if ('ResizeObserver' in window) {
                                    var scAnnouncementObserver = new ResizeObserver(scMeasureAnnouncementBar);
                                        var scAttachAnnouncementObserver = function () {
                                              var bar = document.querySelector('.utility-bar__grid') || document.querySelector('.utility-bar');
                                                    if (bar) scAnnouncementObserver.observe(bar);
                                                        };
                                                            scAttachAnnouncementObserver();
                                                                window.setTimeout(scAttachAnnouncementObserver, 800);
                                                                    window.setTimeout(scAttachAnnouncementObserver, 1500);
                                                                      }
                                                                      })();

function initializeSolcozmProductGallery(pdp) {
  if (!pdp || pdp.dataset.scGalleryInitialized === 'true') return;

  var carousel = pdp.querySelector('[data-sc-pdp-carousel]');
  var track = carousel && carousel.querySelector('[data-sc-pdp-track]');
  var frames = track ? Array.prototype.slice.call(track.querySelectorAll('[data-sc-pdp-frame]')) : [];
  if (!carousel || !track || !frames.length) return;

  pdp.dataset.scGalleryInitialized = 'true';
  var controller = new AbortController();
  var listenerOptions = { signal: controller.signal };
  var passiveOptions = { passive: true, signal: controller.signal };
  var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-sc-pdp-dot]'));
  var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('[data-sc-pdp-thumb]'));
  var previousButton = carousel.querySelector('[data-sc-pdp-prev]');
  var nextButton = carousel.querySelector('[data-sc-pdp-next]');
  var zoomButton = carousel.querySelector('[data-sc-pdp-zoom]');
  var modal = pdp.querySelector('[data-sc-gallery-modal]');
  var modalBackdrop = modal && modal.querySelector('[data-sc-gallery-backdrop]');
  var modalDialog = modal && modal.querySelector('[role="dialog"]');
  var modalZoom = modal && modal.querySelector('[data-sc-gallery-zoom]');
  var modalImage = modal && modal.querySelector('[data-sc-gallery-image]');
  var modalPrevious = modal && modal.querySelector('[data-sc-gallery-prev]');
  var modalNext = modal && modal.querySelector('[data-sc-gallery-next]');
  // 2026-10-12: indice iniziale renderizzato da Liquid (foto del colore della variante selezionata)
  var currentIndex = Math.min(frames.length - 1, Math.max(0, parseInt(track.getAttribute('data-start-index'), 10) || 0));
  var touchStartX = null;
  var modalTouchStartX = null;
  var zoomOpener = null;
  var isZoomed = false;
  var panX = 0;
  var panY = 0;
  var dragStartX = 0;
  var dragStartY = 0;
  var dragOriginX = 0;
  var dragOriginY = 0;
  var activePointerId = null;
  var suppressZoomClick = false;
  var mainPointerId = null;
  var mainPointerStartX = 0;
  var mainPointerStartY = 0;
  var mainPointerMoved = false;

  function currentImage() {
    return frames[currentIndex].querySelector('img:not([aria-hidden="true"])');
  }

  function updateModalImage() {
    if (!modalImage) return;
    var image = currentImage();
    if (!image) return;
    modalImage.src = image.currentSrc || image.src;
    modalImage.srcset = image.srcset || '';
    modalImage.alt = image.alt || '';
  }

  function renderZoom() {
    if (!modalZoom || !modalImage) return;
    modalZoom.classList.toggle('is-zoomed', isZoomed);
    modalZoom.setAttribute('aria-pressed', isZoomed ? 'true' : 'false');
    modalImage.style.transform = 'translate3d(' + panX + 'px,' + panY + 'px,0) scale(' + (isZoomed ? 2 : 1) + ')';
  }

  function resetZoom() {
    isZoomed = false;
    panX = 0;
    panY = 0;
    activePointerId = null;
    suppressZoomClick = false;
    renderZoom();
  }

  function toggleZoom() {
    isZoomed = !isZoomed;
    panX = 0;
    panY = 0;
    renderZoom();
  }

  function goTo(index) {
    resetZoom();
    currentIndex = (index + frames.length) % frames.length;
    track.style.transform = 'translateX(-' + (currentIndex * (100 / frames.length)) + '%)';
    frames.forEach(function (frame, frameIndex) {
      frame.setAttribute('aria-hidden', frameIndex === currentIndex ? 'false' : 'true');
    });
    dots.forEach(function (dot, dotIndex) {
      var active = dotIndex === currentIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
    thumbs.forEach(function (thumb, thumbIndex) {
      var active = thumbIndex === currentIndex;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });
    updateModalImage();
  }

  function goToMedia(mediaId) {
    var wanted = String(mediaId || '');
    var index = frames.findIndex(function (frame) { return frame.dataset.mediaId === wanted; });
    if (index >= 0) goTo(index);
  }

  function openModal(opener) {
    if (!modal || !modalDialog) return;
    zoomOpener = opener || document.activeElement;
    resetZoom();
    updateModalImage();
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sc-gallery-modal-open');
    modalDialog.focus();
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    resetZoom();
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sc-gallery-modal-open');
    if (zoomOpener && document.contains(zoomOpener)) zoomOpener.focus();
  }

  function handleKeys(event) {
    if (!modal || modal.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      goTo(currentIndex - 1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      goTo(currentIndex + 1);
    } else if (event.key === 'Tab') {
      var focusable = Array.prototype.slice.call(modal.querySelectorAll('button:not([disabled])'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === modalDialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  dots.forEach(function (dot, index) { dot.addEventListener('click', function () { goTo(index); }, listenerOptions); });
  thumbs.forEach(function (thumb, index) { thumb.addEventListener('click', function () { goTo(index); }, listenerOptions); });
  if (previousButton) previousButton.addEventListener('click', function () { goTo(currentIndex - 1); }, listenerOptions);
  if (nextButton) nextButton.addEventListener('click', function () { goTo(currentIndex + 1); }, listenerOptions);
  if (zoomButton) {
    zoomButton.addEventListener('click', function (event) {
      event.stopPropagation();
      openModal(zoomButton);
    }, listenerOptions);
  }
  if (modalZoom) {
    modalZoom.addEventListener('click', function () {
      if (suppressZoomClick) {
        suppressZoomClick = false;
        return;
      }
      toggleZoom();
    }, listenerOptions);
    modalZoom.addEventListener('pointerdown', function (event) {
      if (!isZoomed || event.button > 0) return;
      activePointerId = event.pointerId;
      dragStartX = event.clientX;
      dragStartY = event.clientY;
      dragOriginX = panX;
      dragOriginY = panY;
      modalZoom.setPointerCapture(event.pointerId);
      event.preventDefault();
    }, listenerOptions);
    modalZoom.addEventListener('pointermove', function (event) {
      if (!isZoomed || event.pointerId !== activePointerId) return;
      var moveX = event.clientX - dragStartX;
      var moveY = event.clientY - dragStartY;
      if (Math.abs(moveX) > 3 || Math.abs(moveY) > 3) suppressZoomClick = true;
      panX = dragOriginX + moveX;
      panY = dragOriginY + moveY;
      renderZoom();
    }, listenerOptions);
    modalZoom.addEventListener('pointerup', function (event) {
      if (event.pointerId === activePointerId) activePointerId = null;
    }, listenerOptions);
    modalZoom.addEventListener('pointercancel', function (event) {
      if (event.pointerId === activePointerId) activePointerId = null;
    }, listenerOptions);
  }
  if (modalPrevious) modalPrevious.addEventListener('click', function () { goTo(currentIndex - 1); }, listenerOptions);
  if (modalNext) modalNext.addEventListener('click', function () { goTo(currentIndex + 1); }, listenerOptions);
  if (modal) {
    modal.querySelectorAll('[data-sc-gallery-close]').forEach(function (button) {
      button.addEventListener('click', closeModal, listenerOptions);
    });
    modal.addEventListener('click', function (event) {
      if (event.target === modalBackdrop) closeModal();
    }, listenerOptions);
    modal.addEventListener('touchstart', function (event) { modalTouchStartX = event.touches[0].clientX; }, passiveOptions);
    modal.addEventListener('touchend', function (event) {
      if (modalTouchStartX === null) return;
      var delta = event.changedTouches[0].clientX - modalTouchStartX;
      if (!isZoomed && Math.abs(delta) > 40) goTo(currentIndex + (delta < 0 ? 1 : -1));
      modalTouchStartX = null;
    }, passiveOptions);
  }
  carousel.addEventListener('pointerdown', function (event) {
    var image = event.target.closest('[data-sc-pdp-frame] > img:not([aria-hidden="true"])');
    var frame = image && image.closest('[data-sc-pdp-frame]');
    if (!image || frame !== frames[currentIndex] || event.button > 0) return;
    mainPointerId = event.pointerId;
    mainPointerStartX = event.clientX;
    mainPointerStartY = event.clientY;
    mainPointerMoved = false;
  }, listenerOptions);
  carousel.addEventListener('pointermove', function (event) {
    if (event.pointerId !== mainPointerId) return;
    if (Math.abs(event.clientX - mainPointerStartX) > 8 || Math.abs(event.clientY - mainPointerStartY) > 8) {
      mainPointerMoved = true;
    }
  }, listenerOptions);
  carousel.addEventListener('pointerup', function (event) {
    if (event.pointerId !== mainPointerId) return;
    var image = event.target.closest('[data-sc-pdp-frame] > img:not([aria-hidden="true"])');
    var frame = image && image.closest('[data-sc-pdp-frame]');
    var shouldOpen = !mainPointerMoved && image && frame === frames[currentIndex];
    mainPointerId = null;
    if (shouldOpen) openModal(carousel);
  }, listenerOptions);
  carousel.addEventListener('pointercancel', function (event) {
    if (event.pointerId === mainPointerId) mainPointerId = null;
  }, listenerOptions);
  carousel.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      goTo(currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
    } else if ((event.key === 'Enter' || event.key === ' ') && event.target === carousel) {
      event.preventDefault();
      openModal(carousel);
    }
  }, listenerOptions);
  carousel.addEventListener('touchstart', function (event) { touchStartX = event.touches[0].clientX; }, passiveOptions);
  carousel.addEventListener('touchend', function (event) {
    if (touchStartX === null) return;
    var delta = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(delta) > 40) goTo(currentIndex + (delta < 0 ? 1 : -1));
    touchStartX = null;
  }, passiveOptions);
  document.addEventListener('keydown', handleKeys, listenerOptions);

  if (frames.length === 1) {
    [previousButton, nextButton, modalPrevious, modalNext].forEach(function (button) {
      if (button) button.disabled = true;
    });
  }

  pdp.scGallery = { goTo: goTo, goToMedia: goToMedia, destroy: function () { controller.abort(); } };
  // Posizione iniziale senza animazione (evita lo scorrimento visibile dalla prima foto)
  var initialTransition = track.style.transition;
  track.style.transition = 'none';
  goTo(currentIndex);
  void track.offsetWidth;
  track.style.transition = initialTransition;
}

document.addEventListener('shopify:section:load', function (event) {
  var pdp = event.target.querySelector('[data-sc-product]');
  if (pdp) initializeSolcozmProductGallery(pdp);
});

document.addEventListener('shopify:section:unload', function (event) {
  var pdp = event.target.querySelector('[data-sc-product]');
  if (pdp && pdp.scGallery) pdp.scGallery.destroy();
});

document.addEventListener('DOMContentLoaded', function () {
  var reveals = document.querySelectorAll('.sc-reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    reveals.forEach(function (el) { io.observe(el); });
    window.setTimeout(function () {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    }, 1200);
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  function initializeSolcozmHeader(root) {
  var scope = root || document;
  var header = scope.querySelector('[data-sc-header]');
  if (!header || header.dataset.scHeaderInitialized === 'true') return;
  header.dataset.scHeaderInitialized = 'true';
  var headerController = new AbortController();
  var headerListenerOptions = { signal: headerController.signal };
  header.scHeaderDestroy = function () { headerController.abort(); };
  var burger = scope.querySelector('[data-sc-burger]');
  var mobileNav = scope.querySelector('[data-sc-mobile-nav]');
  var mobileOverlay = scope.querySelector('[data-sc-mobile-overlay]');
  var mobileClose = scope.querySelector('[data-sc-mobile-close]');
  if (burger && mobileNav) {
    var scrollLockY = 0;
    var mobileNavPreviouslyFocused = null;
    function getMobileNavFocusable() {
      return Array.prototype.slice.call(
        mobileNav.querySelectorAll(
          'a[href], summary, button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (el) { return el.offsetParent !== null; });
    }
    function handleMobileNavKeydown(e) {
      if (e.key !== 'Tab') return;
      var focusable = getMobileNavFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    function openMobileNav() {
      scrollLockY = window.scrollY || window.pageYOffset || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = (-scrollLockY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      mobileNav.inert = false;
      mobileNav.setAttribute('data-open', 'true');
      burger.setAttribute('aria-expanded', 'true');
      if (mobileOverlay) mobileOverlay.classList.add('is-visible');
      mobileNavPreviouslyFocused = document.activeElement;
      mobileNav.addEventListener('keydown', handleMobileNavKeydown);
      window.setTimeout(function () {
        var focusable = getMobileNavFocusable();
        (focusable[0] || mobileNav).focus();
      }, 50);
    }
    function closeMobileNav() {
      if (mobileNav.getAttribute('data-open') !== 'true') return;
      mobileNav.inert = true;
      mobileNav.setAttribute('data-open', 'false');
      burger.setAttribute('aria-expanded', 'false');
      if (mobileOverlay) mobileOverlay.classList.remove('is-visible');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollLockY);
      mobileNav.removeEventListener('keydown', handleMobileNavKeydown);
      if (mobileNavPreviouslyFocused && typeof mobileNavPreviouslyFocused.focus === 'function') {
        mobileNavPreviouslyFocused.focus();
      }
      mobileNavPreviouslyFocused = null;
    }
    burger.addEventListener('click', function () {
      var open = mobileNav.getAttribute('data-open') === 'true';
      if (open) { closeMobileNav(); } else { openMobileNav(); }
    }, headerListenerOptions);
    if (mobileClose) mobileClose.addEventListener('click', closeMobileNav, headerListenerOptions);
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav, headerListenerOptions);
    mobileNav.querySelectorAll('.sc-mobile-nav__links a').forEach(function (link) {
      link.addEventListener('click', closeMobileNav, headerListenerOptions);
    });
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') closeMobileNav();
    }, headerListenerOptions);
  }

  var activeLocTrigger = null;
  function closeAllLocDropdowns(returnFocus) {
    scope.querySelectorAll('[data-sc-loc-dropdown].is-open').forEach(function (d) {
      d.classList.remove('is-open');
      var t = d.querySelector('[data-sc-loc-trigger]');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    if (returnFocus && activeLocTrigger && document.contains(activeLocTrigger)) activeLocTrigger.focus();
    activeLocTrigger = null;
  }
  scope.querySelectorAll('[data-sc-loc-dropdown]').forEach(function (dropdown) {
    var trigger = dropdown.querySelector('[data-sc-loc-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var wasOpen = dropdown.classList.contains('is-open');
      closeAllLocDropdowns();
      if (!wasOpen) {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        activeLocTrigger = trigger;
      }
    }, headerListenerOptions);
  });
  document.addEventListener('click', function () { closeAllLocDropdowns(false); }, headerListenerOptions);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !activeLocTrigger) return;
    event.preventDefault();
    closeAllLocDropdowns(true);
  }, headerListenerOptions);

  if (header) {
    var onScroll = function () {
      if (window.scrollY > 40) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true, signal: headerController.signal });
  }

  scope.querySelectorAll('.sc-nav-item--has-dropdown').forEach(function (item) {
    var trigger = item.querySelector('[aria-controls]');
    if (!trigger) return;
    var setExpanded = function (expanded) { trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false'); };
    item.addEventListener('mouseenter', function () { setExpanded(true); }, headerListenerOptions);
    item.addEventListener('mouseleave', function () { setExpanded(false); }, headerListenerOptions);
    item.addEventListener('focusin', function () { setExpanded(true); }, headerListenerOptions);
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) setExpanded(false);
    }, headerListenerOptions);
  });
  }

  initializeSolcozmHeader(document);
  document.addEventListener('shopify:section:load', function (event) { initializeSolcozmHeader(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var header = event.target.querySelector('[data-sc-header]');
    if (header && header.scHeaderDestroy) header.scHeaderDestroy();
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-sc-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  var cartBadgeSyncSeq = 0;
  function fetchCartAndUpdateBadge() {
    var seq = ++cartBadgeSyncSeq;
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (seq === cartBadgeSyncSeq) updateCartCount(cart.item_count);
        return cart;
      });
  }

  function syncCartBadge() {
    fetchCartAndUpdateBadge().catch(function () {});
  }

  if (typeof subscribe === 'function') {
    subscribe('cart-update', function (event) {
      if (event && event.cartData && typeof event.cartData.item_count !== 'undefined') {
        updateCartCount(event.cartData.item_count);
      }
    });
  }

  function refreshCartDrawerAndOpen(triggeredBy) {
    var sectionsUrl = new URL(window.location.href);
    sectionsUrl.searchParams.set('sections', 'cart-drawer,cart-icon-bubble');
    return fetch(sectionsUrl.toString())
      .then(function (res) {
        if (!res.ok) throw new Error('Unable to refresh cart drawer');
        return res.json();
      })
      .then(function (sections) {
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl && typeof drawerEl.renderContents === 'function') {
          drawerEl.renderContents({ sections: sections, triggeredBy: triggeredBy });
        } else if (drawerEl) {
          if (sections['cart-drawer']) {
            var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            var newInner = doc.querySelector('#CartDrawer');
            if (newInner) {
              drawerEl.innerHTML = newInner.outerHTML;
              drawerEl.classList.remove('is-empty');
            }
          }
          if (typeof drawerEl.open === 'function') {
            drawerEl.open(triggeredBy);
          }
        }
        return sections;
      });
  }

  function addToCart(variantId, quantity, button) {
    if (!variantId) return;
    var label = button ? button.querySelector('[data-sc-add-label]') : null;
    var originalText = label ? label.textContent : null;
    if (button) button.disabled = true;
    if (label) label.textContent = label.getAttribute('data-loading-text') || '...';

    fetch(window.Shopify && window.routes ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (payload) {
          var hasPayloadError = payload && (payload.error || payload.errors || parseInt(payload.status, 10) >= 400);
          if (!res.ok || hasPayloadError) {
            var errorMessage = payload.description || payload.message;
            if (!errorMessage && typeof payload.error === 'string') errorMessage = payload.error;
            if (!errorMessage && typeof payload.errors === 'string') errorMessage = payload.errors;
            throw new Error(errorMessage || (window.solcozmStrings ? window.solcozmStrings.error : 'Error'));
          }
          return payload;
        });
      })
      .then(function () {
        return fetchCartAndUpdateBadge();
      })
      .then(function () {
        if (label) label.textContent = label.getAttribute('data-success-text') || '\u2713';
        setTimeout(function () {
          if (label && originalText) label.textContent = originalText;
          if (button) button.disabled = false;
        }, 1400);
        return refreshCartDrawerAndOpen(button);
      })
      .catch(function (error) {
        if (label) label.textContent = error.message || (window.solcozmStrings ? window.solcozmStrings.error : 'Error');
        if (button) button.disabled = false;
        setTimeout(function () {
          if (label && originalText) label.textContent = originalText;
        }, 2400);
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-sc-add-to-cart]');
    if (!btn || btn.closest('[data-sc-quickview-modal]')) return;
    addToCart(btn.getAttribute('data-variant-id'), 1, btn);
  });

  document.querySelectorAll('[data-sc-product-card]').forEach(function (card) {
    var variantsScript = card.querySelector('[data-sc-variants]');
    var optionsScript = card.querySelector('[data-sc-options]');
    if (!variantsScript || !optionsScript) return;

    var variants = [];
    var options = { colorIndex: 0, sizeIndex: 0 };
    try {
      variants = JSON.parse(variantsScript.textContent);
      options = JSON.parse(optionsScript.textContent);
    } catch (e) { return; }

    var frontImg = card.querySelector('[data-sc-front-img]');
    var swapImg = card.querySelector('[data-sc-swap-img]');
    var priceEl = card.querySelector('[data-sc-card-price]');
    var addBtn = card.querySelector('[data-sc-add-to-cart]');
    var swatches = card.querySelectorAll('[data-sc-swatch]');
    var sizePills = card.querySelectorAll('[data-sc-size]');

    var selectedColor = null;
    var selectedSize = null;

    function optionValue(variant, index) {
      if (index === 1) return variant.option1;
      if (index === 2) return variant.option2;
      if (index === 3) return variant.option3;
      return null;
    }

    function findVariant() {
      return variants.find(function (v) {
        var colorMatch = options.colorIndex ? optionValue(v, options.colorIndex) === selectedColor : true;
        var sizeMatch = options.sizeIndex ? optionValue(v, options.sizeIndex) === selectedSize : true;
        return colorMatch && sizeMatch;
      });
    }

    function refreshSizeAvailability() {
      if (!options.sizeIndex) return;
      sizePills.forEach(function (pill) {
        var size = pill.getAttribute('data-size');
        var match = variants.find(function (v) {
          var colorMatch = options.colorIndex ? optionValue(v, options.colorIndex) === selectedColor : true;
          return colorMatch && optionValue(v, options.sizeIndex) === size;
        });
        var available = match ? match.available : false;
        pill.disabled = !available;
        pill.classList.toggle('sc-size-pill--oos', !available);
      });
    }

    function updateSelection() {
      var variant = findVariant();
      if (variant && addBtn) addBtn.setAttribute('data-variant-id', variant.id);
      if (variant && priceEl) priceEl.textContent = formatMoney(variant.price);
    }

    function formatMoney(cents) {
      var amount = (parseInt(cents, 10) / 100).toFixed(2);
      return (window.Shopify && window.Shopify.currency ? '' : '') + amount;
    }

    function swapFrontImage(newSrc, img2x) {
      if (!frontImg || !newSrc) return;
      if (!swapImg) {
        frontImg.src = newSrc;
        if (img2x) frontImg.srcset = newSrc + ' 1x, ' + img2x + ' 2x';
        return;
      }
      var settle = function () {
        swapImg.style.opacity = '1';
        window.setTimeout(function () {
          frontImg.src = newSrc;
          if (img2x) frontImg.srcset = newSrc + ' 1x, ' + img2x + ' 2x';
          swapImg.style.opacity = '0';
        }, 350);
      };
      swapImg.src = newSrc;
      if (img2x) swapImg.srcset = newSrc + ' 1x, ' + img2x + ' 2x';
      if (swapImg.decode) {
        swapImg.decode().then(settle).catch(settle);
      } else {
        swapImg.onload = settle;
        swapImg.onerror = settle;
      }
    }

    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        selectedColor = sw.getAttribute('data-color');
        swatches.forEach(function (s) { s.classList.remove('is-selected'); });
        sw.classList.add('is-selected');
        swapFrontImage(sw.getAttribute('data-image'), sw.getAttribute('data-image-2x'));
        refreshSizeAvailability();
        updateSelection();
      });
    });

    sizePills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        selectedSize = pill.getAttribute('data-size');
        sizePills.forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        updateSelection();
      });
    });
  });

  function initializeSolcozmCardMedia(media) {
    if (!media || media.dataset.scCardMediaInitialized === 'true') return;
    media.dataset.scCardMediaInitialized = 'true';
    var track = media.querySelector('[data-sc-card-track]');
    if (!track) return;
    var dots = media.querySelectorAll('[data-sc-card-dot]');
    var frames = track.querySelectorAll('[data-sc-card-frame]');
    if (frames.length < 2) return;
    var cardController = new AbortController();
    var cardListenerOptions = { signal: cardController.signal };
    var cardPassiveOptions = { passive: true, signal: cardController.signal };
    var current = 0;

    function goTo(index) {
      current = (index + frames.length) % frames.length;
      var stepPercent = 100 / frames.length;
      track.style.transform = 'translateX(-' + (current * stepPercent) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
    }

    var hoverTimer = null;
    media.addEventListener('mouseenter', function () {
      hoverTimer = setInterval(function () { goTo(current + 1); }, 900);
    }, cardListenerOptions);
    media.addEventListener('mouseleave', function () {
      clearInterval(hoverTimer);
      goTo(0);
    }, cardListenerOptions);

    var startX = null;
    media.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, cardPassiveOptions);
    media.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var deltaX = e.changedTouches[0].clientX - startX;
      if (Math.abs(deltaX) > 30) goTo(current + (deltaX < 0 ? 1 : -1));
      startX = null;
    }, cardPassiveOptions);

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (evt) {
        evt.preventDefault();
        goTo(i);
      }, cardListenerOptions);
    });
    media.scCardMediaDestroy = function () {
      clearInterval(hoverTimer);
      cardController.abort();
    };
  }

  document.querySelectorAll('[data-sc-card-media]').forEach(initializeSolcozmCardMedia);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-sc-card-media]').forEach(initializeSolcozmCardMedia);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-sc-card-media]').forEach(function (media) {
      if (media.scCardMediaDestroy) media.scCardMediaDestroy();
    });
  });

  function getModalFocusable(modal) {
    return Array.prototype.slice.call(
      modal.querySelectorAll(
        'a[href], summary, button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) { return element.offsetParent !== null; });
  }

  function handleAccessibleModalKeydown(event) {
    var modal = event.currentTarget;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeAccessibleModal(modal);
      return;
    }
    if (event.key !== 'Tab') return;

    var focusable = getModalFocusable(modal);
    if (!focusable.length) {
      event.preventDefault();
      modal.querySelector('[role="dialog"]')?.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openAccessibleModal(modal, trigger) {
    modal._scModalTrigger = trigger || document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    modal.setAttribute('data-open', 'true');
    modal.addEventListener('keydown', handleAccessibleModalKeydown);
    window.setTimeout(function () {
      var focusable = getModalFocusable(modal);
      var focusTarget = focusable[0] || modal.querySelector('[role="dialog"]');
      if (focusTarget) focusTarget.focus();
    }, 0);
  }

  function closeAccessibleModal(modal) {
    if (!modal || modal.getAttribute('data-open') !== 'true') return;
    modal.setAttribute('data-open', 'false');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    modal.removeEventListener('keydown', handleAccessibleModalKeydown);
    var trigger = modal._scModalTrigger;
    modal._scModalTrigger = null;
    if (trigger && typeof trigger.focus === 'function') trigger.focus();
  }

  var qvModal = document.querySelector('[data-sc-quickview-modal]');
  if (qvModal) {
    var qvBody = qvModal.querySelector('[data-sc-quickview-body]');

    function qvClose() {
      closeAccessibleModal(qvModal);
    }
    qvModal.querySelectorAll('[data-sc-quickview-close]').forEach(function (el) {
      el.addEventListener('click', qvClose);
    });
    function qvFormatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CHF'
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    function qvRender(product) {
      var variant = product.variants[0];
      var selected = {};
      product.options.forEach(function (name, i) {
        selected[i + 1] = variant['option' + (i + 1)];
      });

      function findVariant() {
        return product.variants.find(function (v) {
          return Object.keys(selected).every(function (idx) {
            return v['option' + idx] === selected[idx];
          });
        });
      }

      function optionValueIsAvailable(optionIndex, optionValue) {
        return product.variants.some(function (candidate) {
          if (!candidate.available || candidate['option' + optionIndex] !== optionValue) return false;
          return Object.keys(selected).every(function (selectedIndex) {
            return selectedIndex === String(optionIndex) || candidate['option' + selectedIndex] === selected[selectedIndex];
          });
        });
      }

      var optionsHtml = '';
      product.options.forEach(function (rawName, i) {
        var name = (rawName && typeof rawName === 'object') ? (rawName.name || '') : rawName;
        var idx = i + 1;
        var values = [];
        product.variants.forEach(function (v) {
          var val = v['option' + idx];
          if (values.indexOf(val) === -1) values.push(val);
        });
        optionsHtml += '<div class="sc-qv-option" data-qv-option="' + idx + '">' +
          '<span class="sc-qv-option-label">' + name + '</span>' +
          '<div class="sc-qv-option-values">' +
          values.map(function (val) {
            var available = optionValueIsAvailable(idx, val);
            var isSelected = val === selected[idx];
            return '<button type="button" class="sc-qv-pill' + (isSelected ? ' is-selected' : '') + '"' +
              (available ? '' : ' disabled') + ' data-qv-value="' + val.replace(/"/g, '&quot;') + '">' + val + '</button>';
          }).join('') +
          '</div></div>';
      });

      qvBody.innerHTML =
        '<div class="sc-qv-grid">' +
        '<div class="sc-qv-media"><img data-qv-image src="' + (variant.featured_image ? variant.featured_image.src : (product.featured_image || '')) + '&width=900" alt="' + product.title.replace(/"/g, '&quot;') + '"></div>' +
        '<div>' +
        '<h3 class="sc-qv-title">' + product.title + '</h3>' +
        '<p class="sc-qv-price" data-qv-price>' + qvFormatMoney(variant.price) + '</p>' +
        optionsHtml +
        '<button type="button" class="sc-btn sc-btn--dark sc-qv-add" data-sc-add-to-cart data-variant-id="' + variant.id + '" ' + (variant.available ? '' : 'disabled') + '>' +
        '<span data-sc-add-label>' + (variant.available ? (window.variantStrings ? window.variantStrings.addToCart : 'Add to cart') : (window.variantStrings ? window.variantStrings.soldOut : 'Sold out')) + '</span>' +
        '</button>' +
        '<a class="sc-qv-viewfull" href="' + product.url + '">' + (window.variantStrings ? '' : '') + '</a>' +
        '</div></div>';

      var viewFullLink = qvBody.querySelector('.sc-qv-viewfull');
      if (viewFullLink) viewFullLink.textContent = product.url ? (window.solcozmStrings ? window.solcozmStrings.viewFullDetails : 'View full details') : '';

      function refreshQuickViewOptionAvailability() {
        qvBody.querySelectorAll('[data-qv-option]').forEach(function (group) {
          var optionIndex = group.getAttribute('data-qv-option');
          group.querySelectorAll('[data-qv-value]').forEach(function (button) {
            button.disabled = !optionValueIsAvailable(optionIndex, button.getAttribute('data-qv-value'));
          });
        });
      }

      function updateQuickViewVariant(newVariant) {
        var addBtn = qvBody.querySelector('[data-sc-add-to-cart]');
        if (!addBtn) return;
        var addLabel = addBtn.querySelector('[data-sc-add-label]');

        if (!newVariant) {
          addBtn.removeAttribute('data-variant-id');
          addBtn.disabled = true;
          if (addLabel) addLabel.textContent = window.variantStrings ? window.variantStrings.unavailable : 'Unavailable';
          return;
        }

        addBtn.setAttribute('data-variant-id', newVariant.id);
        addBtn.disabled = !newVariant.available;
        if (addLabel) {
          addLabel.textContent = newVariant.available
            ? (window.variantStrings ? window.variantStrings.addToCart : 'Add to cart')
            : (window.variantStrings ? window.variantStrings.soldOut : 'Sold out');
        }
      }

      qvBody.querySelectorAll('[data-qv-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          var group = btn.closest('[data-qv-option]');
          var idx = group.getAttribute('data-qv-option');
          selected[idx] = btn.getAttribute('data-qv-value');
          group.querySelectorAll('.sc-qv-pill').forEach(function (p) { p.classList.remove('is-selected'); });
          btn.classList.add('is-selected');

          refreshQuickViewOptionAvailability();
          var newVariant = findVariant();
          if (newVariant) {
            var priceEl = qvBody.querySelector('[data-qv-price]');
            if (priceEl) priceEl.textContent = qvFormatMoney(newVariant.price);
            var imgEl = qvBody.querySelector('[data-qv-image]');
            if (imgEl && newVariant.featured_image) imgEl.src = newVariant.featured_image.src + '&width=900';
          }
          updateQuickViewVariant(newVariant);
        });
      });

      qvBody.querySelectorAll('[data-sc-add-to-cart]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          addToCart(btn.getAttribute('data-variant-id'), 1, btn);
        });
      });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-sc-quickview]');
      if (!trigger) return;
      e.preventDefault();
      var url = trigger.getAttribute('data-product-url');
      if (!url) return;
      var cleanUrl = url.split('?')[0].split('#')[0];
      qvBody.innerHTML = '<div class="sc-quickview__loading">' + (window.solcozmStrings ? window.solcozmStrings.loading : '...') + '</div>';
      openAccessibleModal(qvModal, trigger);
      fetch(cleanUrl + '.js')
        .then(function (res) { return res.json(); })
        .then(qvRender)
        .catch(function () {
          qvBody.innerHTML = '<div class="sc-quickview__loading">' + (window.solcozmStrings ? window.solcozmStrings.error : 'Error') + '</div>';
        });
    });
  }

  function initializeSolcozmProductControls(pdp) {
    if (!pdp || pdp.dataset.scProductInitialized === 'true') return;
    pdp.dataset.scProductInitialized = 'true';
    var productController = new AbortController();
    var productListenerOptions = { signal: productController.signal };
    var productPassiveOptions = { passive: true, signal: productController.signal };
    pdp.scProductDestroy = function () { productController.abort(); };
    initializeSolcozmProductGallery(pdp);

    var pdpVariantsScript = pdp.querySelector('[data-sc-pdp-variants]');
    var pdpOptionsScript = pdp.querySelector('[data-sc-pdp-options]');
    var pdpVariants = [];
    var pdpOptions = {};
    try {
      pdpVariants = JSON.parse(pdpVariantsScript.textContent);
      pdpOptions = JSON.parse(pdpOptionsScript.textContent);
    } catch (e) { pdpVariants = []; }

    var mainImage = pdp.querySelector('[data-sc-pdp-main-image]');
    var pdpSwapImage = pdp.querySelector('[data-sc-pdp-swap-image]');
    var priceEl = pdp.querySelector('[data-sc-pdp-price]');
    var addBtn = pdp.querySelector('[data-sc-pdp-add]');
    var availabilityEl = pdp.querySelector('[data-sc-pdp-availability]');
    var selected = {};

    pdp.querySelectorAll('[data-sc-pdp-option]').forEach(function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      var buttons = group.querySelectorAll('[data-value]');
      buttons.forEach(function (btn) {
        if (btn.classList.contains('is-selected')) selected[index] = btn.getAttribute('data-value');
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          selected[index] = btn.getAttribute('data-value');
          pdpUpdate(index, true);
        }, productListenerOptions);
      });
    });

    function pdpFindVariant() {
      // Solo la variante che corrisponde ESATTAMENTE alla scelta del cliente (2026-10-12: nessuna sostituzione
      // automatica della taglia o di altre opzioni).
      return pdpVariants.find(function (v) {
        return Object.keys(selected).every(function (idx) {
          return v['option' + idx] === selected[idx];
        });
      });
    }

    function pdpSyncUrl(variant) {
      // Come Dawn: ?variant= nell'URL (replaceState: nessuna voce in più nella cronologia),
      // così reload, condivisione e Indietro/Avanti riaprono la stessa scelta.
      // Combinazione inesistente: il parametro viene tolto (nessun ID variante che non corrisponde alla scelta).
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        if (variant) url.searchParams.set('variant', variant.id);
        else url.searchParams.delete('variant');
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) {}
    }

    function pdpSelectVariantOptions(variant) {
      pdp.querySelectorAll('[data-sc-pdp-option]').forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        if (variant) selected[index] = variant['option' + index];
        group.querySelectorAll('[data-value]').forEach(function (btn) {
          var isSelected = btn.getAttribute('data-value') === selected[index];
          btn.classList.toggle('is-selected', isSelected);
          btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      });
    }

    function pdpRefreshOptionAvailability() {
      var colorIndex = parseInt(pdpOptions.colorIndex, 10) || 0;
      pdp.querySelectorAll('[data-sc-pdp-option]').forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        group.querySelectorAll('[data-value]').forEach(function (btn) {
          var value = btn.getAttribute('data-value');
          var compatible = pdpVariants.some(function (variant) {
            if (!variant.available || variant['option' + index] !== value) return false;
            return Object.keys(selected).every(function (selectedIndex) {
              return parseInt(selectedIndex, 10) === index || variant['option' + selectedIndex] === selected[selectedIndex];
            });
          });
          if (index === colorIndex) {
            // Il colore resta sempre selezionabile: mostra subito la sua foto; la taglia scelta non viene cambiata.
            var colorExists = pdpVariants.some(function (variant) { return variant['option' + index] === value; });
            btn.disabled = !colorExists;
            btn.classList.toggle('is-unavailable', colorExists && !compatible);
            btn.setAttribute('aria-disabled', colorExists ? 'false' : 'true');
          } else {
            btn.disabled = !compatible;
            btn.setAttribute('aria-disabled', compatible ? 'false' : 'true');
          }
        });
      });
    }

    function pdpShowPrice(variant) {
      if (!priceEl || !variant) return;
      priceEl.replaceChildren();
      if (variant.on_sale) {
        var comparePrice = document.createElement('s');
        comparePrice.textContent = variant.compare_at_price_formatted;
        priceEl.append(comparePrice, document.createTextNode(' '));
      }
      priceEl.append(document.createTextNode(variant.price_formatted));
    }

    var pdpNotice = pdp.querySelector('[data-sc-pdp-notice]');
    function pdpSetNotice(text) {
      if (!pdpNotice) return;
      pdpNotice.textContent = text || '';
      pdpNotice.hidden = !text;
    }
    function pdpSizeNotice() {
      // «La taglia XL non è disponibile nel colore selezionato. Scegli un'altra taglia.» (IT/DE/EN, role=status)
      var sizeIdx = parseInt(pdpOptions.sizeIndex, 10) || 0;
      var size = sizeIdx ? selected[sizeIdx] : null;
      if (!size || !pdpNotice) return '';
      return (pdpNotice.getAttribute('data-template') || '').replace('[size]', size);
    }

    function pdpSetUnavailable(fromUser) {
      // Combinazione che non esiste nel catalogo: la scelta del cliente resta visibile, nessuna variante
      // acquistabile nel form, foto e prezzo del colore scelto, avviso esplicito.
      pdpSelectVariantOptions(null);
      var colorIdx = parseInt(pdpOptions.colorIndex, 10) || 0;
      var sameColor = colorIdx ? pdpVariants.filter(function (v) { return v['option' + colorIdx] === selected[colorIdx]; }) : [];
      var colorRef = sameColor.find(function (v) { return v.image_id; }) || sameColor[0] || null;
      if (pdp.scGallery && colorRef && colorRef.image_id) pdp.scGallery.goToMedia(colorRef.image_id);
      if (colorRef) pdpShowPrice(colorRef);
      else if (priceEl) priceEl.textContent = addBtn ? addBtn.getAttribute('data-label-invalid') : '';
      if (addBtn) {
        addBtn.removeAttribute('data-variant-id');
        addBtn.disabled = true;
        var label = addBtn.querySelector('[data-sc-add-label]');
        if (label) label.textContent = addBtn.getAttribute('data-label-invalid');
      }
      if (availabilityEl) {
        availabilityEl.textContent = availabilityEl.getAttribute('data-unavailable-text');
        availabilityEl.classList.add('sc-availability--oos');
      }
      if (fromUser) { pdpSyncUrl(null); pdpSetNotice(pdpSizeNotice()); }
      pdpRefreshOptionAvailability();
    }

    function pdpUpdate(changedIndex, fromUser) {
      var variant = pdpFindVariant();
      if (!variant) {
        pdpSetUnavailable(fromUser);
        return;
      }
      // Variante esistente: se esaurita lo si dichiara (pulsante disattivato + avviso), mai sostituita.
      if (fromUser) pdpSetNotice(variant.available ? '' : pdpSizeNotice());
      pdpSelectVariantOptions(variant);
      if (fromUser) pdpSyncUrl(variant);
      // image_id = variant.featured_image.id, lo stesso ID dei fotogrammi della galleria (data-media-id)
      if (pdp.scGallery && variant.image_id) pdp.scGallery.goToMedia(variant.image_id);
      // Senza galleria: sostituzione dell'immagine singola. Con galleria e variante senza immagine associata
      // nel catalogo (image_id null) la galleria resta com'è: nessuna foto di un altro colore viene forzata.
      if (mainImage && variant.image && !pdp.scGallery) {
        var pdpNewSrc = variant.image;
        var pdpImg2x = variant.image2x;
        if (pdpSwapImage) {
          var pdpSettle = function () {
            pdpSwapImage.style.opacity = '1';
            window.setTimeout(function () {
              mainImage.src = pdpNewSrc;
              if (pdpImg2x) mainImage.srcset = pdpNewSrc + ' 1x, ' + pdpImg2x + ' 2x';
              pdpSwapImage.style.opacity = '0';
            }, 350);
          };
          pdpSwapImage.src = pdpNewSrc;
          if (pdpImg2x) pdpSwapImage.srcset = pdpNewSrc + ' 1x, ' + pdpImg2x + ' 2x';
          if (pdpSwapImage.decode) {
            pdpSwapImage.decode().then(pdpSettle).catch(pdpSettle);
          } else {
            pdpSwapImage.onload = pdpSettle;
            pdpSwapImage.onerror = pdpSettle;
          }
        } else {
          var pdpPreloader = new Image();
          pdpPreloader.onload = function () {
            mainImage.src = pdpNewSrc;
            if (pdpImg2x) mainImage.srcset = pdpNewSrc + ' 1x, ' + pdpImg2x + ' 2x';
          };
          pdpPreloader.onerror = pdpPreloader.onload;
          pdpPreloader.src = pdpNewSrc;
        }
      }
      pdpShowPrice(variant);
      if (addBtn) {
        if (variant.available) addBtn.setAttribute('data-variant-id', variant.id);
        else addBtn.removeAttribute('data-variant-id');
        addBtn.disabled = !variant.available;
        var lbl = addBtn.querySelector('[data-sc-add-label]');
        if (lbl) lbl.textContent = variant.available ? addBtn.getAttribute('data-label-available') : addBtn.getAttribute('data-label-unavailable');
      }
      if (availabilityEl) {
        availabilityEl.textContent = variant.available ? availabilityEl.getAttribute('data-in-stock-text') : availabilityEl.getAttribute('data-oos-text');
        availabilityEl.classList.toggle('sc-availability--oos', !variant.available);
      }
      pdpRefreshOptionAvailability();
    }

    pdpUpdate();

    var sizeGuideTrigger = pdp.querySelector('[data-sc-size-guide-open]');
    var sizeGuideModal = document.querySelector('[data-sc-size-guide-modal]');
    if (sizeGuideTrigger && sizeGuideModal) {
      sizeGuideTrigger.addEventListener('click', function () {
        openAccessibleModal(sizeGuideModal, sizeGuideTrigger);
      }, productListenerOptions);
      sizeGuideModal.querySelectorAll('[data-sc-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { closeAccessibleModal(sizeGuideModal); }, productListenerOptions);
      });
    }

    var spin = pdp.querySelector('[data-sc-360]');
    if (spin) {
      var spinFrames = Array.prototype.slice.call(spin.querySelectorAll('[data-sc-360-frame]'));
      if (spinFrames.length > 1) {
        var frameIndex = 0;
        var dragging = false;
        var lastX = 0;

        function showFrame(i) {
          frameIndex = (i + spinFrames.length) % spinFrames.length;
          spinFrames.forEach(function (f, idx) { f.style.display = idx === frameIndex ? 'block' : 'none'; });
        }
        showFrame(0);

        spin.addEventListener('mousedown', function (e) { dragging = true; lastX = e.clientX; }, productListenerOptions);
        window.addEventListener('mouseup', function () { dragging = false; }, productListenerOptions);
        window.addEventListener('mousemove', function (e) {
          if (!dragging) return;
          var delta = e.clientX - lastX;
          if (Math.abs(delta) > 8) {
            showFrame(frameIndex + (delta > 0 ? 1 : -1));
            lastX = e.clientX;
          }
        }, productListenerOptions);

        spin.addEventListener('touchstart', function (e) { lastX = e.touches[0].clientX; }, productPassiveOptions);
        spin.addEventListener('touchmove', function (e) {
          var delta = e.touches[0].clientX - lastX;
          if (Math.abs(delta) > 8) {
            showFrame(frameIndex + (delta > 0 ? 1 : -1));
            lastX = e.touches[0].clientX;
          }
        }, productPassiveOptions);
      }
    }
  }

  document.querySelectorAll('[data-sc-product]').forEach(initializeSolcozmProductControls);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-sc-product]').forEach(initializeSolcozmProductControls);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-sc-product]').forEach(function (product) {
      if (product.scProductDestroy) product.scProductDestroy();
    });
  });
});

/* 2026-10-12 — Localizzazione: i selettori paese devono sempre rappresentare la pagina mostrata.
   Tornando indietro (cache Indietro/Avanti o ripristino dei moduli del browser) il <select> poteva
   mostrare ancora il paese scelto nella pagina successiva (es. «Germania» su una pagina in CHF):
   scegliendo di nuovo quel paese non succedeva nulla. Si riallinea il valore a quello renderizzato
   da Shopify (option[selected]) e si chiudono i pannelli lingua/paese rimasti aperti.
   Nessuna lingua o paese viene forzato: la pagina resta quella dell'URL. */
(function () {
  function scSyncLocalizationForms() {
    document.querySelectorAll('select[name="country_code"]').forEach(function (select) {
      select.setAttribute('autocomplete', 'off');
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].defaultSelected) { select.selectedIndex = i; break; }
      }
    });
    document.querySelectorAll('[data-sc-loc-dropdown].is-open').forEach(function (dropdown) {
      dropdown.classList.remove('is-open');
      var trigger = dropdown.querySelector('[data-sc-loc-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }
  window.addEventListener('pageshow', scSyncLocalizationForms);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scSyncLocalizationForms);
  else scSyncLocalizationForms();
})();
